import React from 'react';
import ServicePageLayout from './ServicePageLayout';

const Ocd = () => (
  <ServicePageLayout
    metaTitle="Specialized OCD Therapy (CBT & ERP) | Therapy with Ayesha"
    title="Specialized OCD Therapy (CBT & ERP)"
    intro="A structured, evidence-based approach to break the obsession–compulsion cycle using Cognitive Behavioral Therapy and Exposure & Response Prevention — the gold-standard treatment for OCD."
    badges={['ERP', 'CBT for OCD', 'Anxiety Hierarchy']}
    sections={[
      {
        heading: 'The Obsession–Compulsion Cycle',
        body: "OCD isn't about being neat or organised. It's a brain stuck in a false-alarm loop. An intrusive thought arrives → your brain treats it as a real threat → anxiety spikes → you perform a compulsion (mental review, washing, checking, reassurance-seeking) to neutralise the discomfort. Relief comes briefly. The next time the thought returns, your brain demands the compulsion even louder. Therapy starts by mapping your specific obsessions, your hidden compulsions (mental ones count), and the moments anxiety peaks.",
      },
      {
        heading: 'Exposure and Response Prevention (ERP)',
        body: 'ERP is the most effective therapy for OCD, with decades of research behind it. The premise is direct: you cannot reason your way out of OCD, but you can teach your brain that the anxiety is survivable.',
        points: [
          "Together we build an anxiety hierarchy — a personalised ladder of triggers from mildly uncomfortable to extremely distressing.",
          "We design exposures that intentionally invite the obsession while resisting the compulsion.",
          "You learn to ride the anxiety wave — observing it rise, plateau, and naturally fall — without performing the ritual.",
          "Each successful exposure rewires the brain's threat-assessment system. The false alarms quiet down.",
        ],
      },
      {
        heading: 'Rewiring the False Alarm System',
        body: "OCD lives in a particular brain circuit (cortico-striato-thalamo-cortical loop) that misfires the 'something is wrong' signal. ERP — done consistently and correctly — physically reshapes how this circuit responds to intrusive content. Over weeks and months, the loud, urgent demand for a compulsion becomes a quieter, easier-to-ignore whisper. This is not about willpower. It is neurological retraining.",
      },
      {
        heading: 'What Our Work Together Looks Like',
        points: [
          'A non-judgmental space to disclose intrusive thoughts (sexual, violent, religious, harm — none of it shocks me; all of it is treatable).',
          'Clear psychoeducation so you understand what your brain is doing and why ERP works.',
          'Structured weekly exposures with detailed tracking and progress mapping.',
          'Relapse-prevention planning so you remain your own therapist long after our work ends.',
        ],
      },
    ]}
  />
);

export default Ocd;
